import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard
  .extend('verification')
  .add('verification.breadcrumb.title', { name: 'verification.trunk.index' });

const trunks_breadcrumbs = module
  .extend('verification.trunk.index')
  .add('verification.breadcrumb.trunk.index', {
    name: `verification.trunk.index`
  });

const stats_breadcrumbs = module
  .extend('verification.stats.type')
  .add('shared.breadcrumb.stats.title', {
    name: `verification.stats.index`
  });

const verification_breadcrumbs = [trunks_breadcrumbs, stats_breadcrumbs];

export { verification_breadcrumbs };
